<mat-drawer-container class="sidenav-container">
  <mat-drawer-content>
    <mat-toolbar color="primary" class="main-toolbar p-0">
      <mat-grid-list cols="2" rowHeight="48px" [style.width]="'100%'">
        <mat-grid-tile rowspan="1">
          <ng-container *ngTemplateOutlet="activePage"></ng-container>
        </mat-grid-tile>
        <mat-grid-tile>
          <ng-container *ngTemplateOutlet="userActions"></ng-container>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-toolbar>
    <div class="content-wrapper">
      @if(isCollapsed && (isAuthenticated$ | async)){
      <mat-toolbar class="mini-sidenav">
        <ng-container *ngTemplateOutlet="menuNavItems"></ng-container>
      </mat-toolbar>}
      <div class="content-container">
        @if(activeRoute$ | async; as activeRoute) {
        @if (isWidget(activeRoute)) {
        <div class="rh-actions-container">
          <ng-container *ngTemplateOutlet="widgets; context: {activeRoute}"></ng-container>
        </div>
        }
        }
        <ng-content></ng-content>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<!-- Active Page Breadcrumb  -->
<ng-template #activePage>
  <div [style.width]="'100%'">
    <button mat-button routerLink="/">
      <img class="rh_topnav_logo" [src]="'/assets/images/RHAPSODY KEY MANAGEMENT.svg'" alt="API Keys Logo" />
    </button>
    <span class="rh-topnav-title mat-body-medium"> <span [style.color]="'white'"
        [style.marginRight]="'0.5rem'">&#x25C6;</span>{{activePage$
      | async}}</span>
  </div>
</ng-template>

<!-- Widgets -->
<ng-template #widgets let-activeRoute="activeRoute">
  <!-- Widgets -->
  @switch (activeRoute) {
  @case ('/dashboard') {<rh-filter></rh-filter>}
  @case ('/create-key') {<rh-create-key></rh-create-key>}
  @case('/api-tester') {<rh-api-tester-controls></rh-api-tester-controls>}
  @case ('/introspect-key') {<rh-introspect-keys-widget></rh-introspect-keys-widget>}
  @default {}
  }
</ng-template>

<!-- Navigation List Items Template -->
<ng-template #menuNavItems>
  <mat-nav-list>
    @for(item of menuItems(showDebugTools); track $index) {
    @if(item.enabled) {
    <mat-list-item [matTooltip]="item.label" matTooltipPosition="right" [routerLink]="item.route"
      routerLinkActive="active-link" (click)="onNavigation(item)">
      <mat-icon matListItemIcon [class.active-icon]="isActive(item.route)">{{ item.icon }}</mat-icon>
    </mat-list-item>
    }
    }
  </mat-nav-list>
</ng-template>

<!-- User Menu Template -->
<ng-template #userActions>
  <div class="rh-user-action-content">
    <button class="rh-user-action-btn" mat-icon-button [matMenuTriggerFor]="menu" aria-label="User menu"
      matTooltip="User Menu">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @if(userEmail) {
      <span mat-menu-item>
        <mat-icon>person</mat-icon>
        <span>{{ userEmail }}</span>
      </span>
      }
      @if((isAuthenticated$ | async)) {
      <button mat-menu-item (click)="loginOutAction.emit()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
      }
    </mat-menu>
  </div>
</ng-template>